import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./tile-label.html';
import styles from './tile-label-hashed.scss';

export default [function () {
    return {
        restrict: 'E',
        scope: {
            state: '&',
            flavor: '='
        },
        transclude: true,
        template: cssUtil.hashTemplate(template, styles),
        controller: ['$scope', function ($scope) {
            $scope.currentFlavor = $scope.flavor || 'Default';
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/tiles/tileLayout/Label/tileLabel.js
// module id = 1171
// module chunks = 0